import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/Store';
import { fetchRooms, fetchRoomMessages } from '@/redux/thunks/chatThunks';
import { useChatSocket } from '@/hooks/useChatSocket';
import RoomList from './components/RoomList';
import ChatRoom from './components/ChatRoom';
import './Chat.scss';

const ChatPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const activeRoomId = useAppSelector((s) => s.chat.activeRoomId);

  // Wire up socket listeners
  useChatSocket(activeRoomId);

  // Load rooms on mount
  useEffect(() => {
    dispatch(fetchRooms());
  }, [dispatch]);

  // Load messages when active room is set
  useEffect(() => {
    if (activeRoomId) {
      dispatch(fetchRoomMessages({ roomId: activeRoomId }));
    }
  }, [activeRoomId, dispatch]);

  return (
    <div className="chat-page">
      <RoomList />
      <ChatRoom />
    </div>
  );
};

export default ChatPage;
